//  Page Title: Setup 2FA Verification for WordPress Sites

import {   MdSettingsEthernet, MdSmartToy, MdAdminPanelSettings, MdPolicy, MdFactCheck, MdSecurity, } from "react-icons/md";

// Main Video: https://youtu.be/mftn-shZx1U
export const aiGovernData = [
    {
        title: "Configure a secure MCP Server for WordPress",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSettingsEthernet className='text-white fs-5' />
    },
    {
        title: "Connect AI clients like ChatGPT, Claude, Gemini, and other MCP-compatible tools",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSmartToy className='text-white fs-5' />
    },
    {
        title: "Enforce role-based AI permissions",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdAdminPanelSettings className='text-white fs-5' />
    },
    {
        title: "Protect sensitive data with policy enforcement",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdPolicy className='text-white fs-5' />
    },
    {
        title: "Monitor AI activity using detailed audit logs",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdFactCheck className='text-white fs-5' />
    },
    {
        title: "Govern WordPress, WooCommerce, REST APIs, and WP-CLI access securely",
        video: false,
        videoId: "",
        videoType: "",
        icon: <MdSecurity className='text-white fs-5' />
    },
]
